// extracted by mini-css-extract-plugin
module.exports = {"flex_row":"SectionList_flex_row__1QpkZ","flex_column":"SectionList_flex_column__2Psgz"};